import { BlogPostType } from '@src/enums'
import { BlogPost, LinkedBlogPostTranslation } from '@src/types'
import { api, ApiRes } from '@src/utils/api/client'

export const getBlogPosts = (
    platformName: string,
    type: BlogPostType,
    language?: string | null
): ApiRes<BlogPost[]> =>
    api.get(`v2/manage/platforms/${platformName}/blog-posts`, {
        params: { type, language: language || undefined },
    })

export const createBlogPost = (
    platformName: string,
    blogPost: BlogPost
): ApiRes<BlogPost> =>
    api.post(`v2/manage/platforms/${platformName}/blog-posts`, blogPost)

// `slug` identifies the post in the URL and must be the slug it is currently
// stored under; `blogPost.slug` may already hold a new, not yet saved slug.
export const updateBlogPost = (
    platformName: string,
    blogPost: BlogPost,
    slug: string
): ApiRes<BlogPost> =>
    api.put(`v2/manage/platforms/${platformName}/blog-posts/${slug}`, blogPost)

export const getBlogPostTranslations = (
    platformName: string,
    slug: string
): ApiRes<BlogPost & { linked_translations: LinkedBlogPostTranslation[] }> =>
    api.get(`v2/manage/platforms/${platformName}/blog-posts/${slug}`)

export const linkBlogPostTranslation = (
    platformName: string,
    slug: string,
    translationSlug: string
): ApiRes<{ linked_translations: LinkedBlogPostTranslation[] }> =>
    api.post(
        `v2/manage/platforms/${platformName}/blog-posts/${slug}/translations`,
        { translation_slug: translationSlug }
    )

export const unlinkBlogPostTranslation = (
    platformName: string,
    slug: string,
    translationSlug: string
): ApiRes<{ linked_translations: LinkedBlogPostTranslation[] }> =>
    api.delete(
        `v2/manage/platforms/${platformName}/blog-posts/${slug}/translations/${translationSlug}`
    )

export const deleteBlogPost = (
    platformName: string,
    slug: string
): ApiRes<void> =>
    api.delete(`v2/manage/platforms/${platformName}/blog-posts/${slug}`)
